import React from 'react';
import { Tooltip } from '../base';
import { MessagingBadge as MessagingBadgeStyled, MessagingPill as MessagingPillStyled } from './messaging-badge.styles';

export interface IMessagingBadgeProps {
    children: React.ReactNode;
    title?: React.ReactNode;
}

export const MessagingBadge: React.FC<IMessagingBadgeProps> = ({ children, title }) => {
    const badge = <MessagingBadgeStyled>{children}</MessagingBadgeStyled>;
    if (title != null && title !== '') {
        return (
            <Tooltip direction="top" title={<span>{title}</span>}>
                {badge}
            </Tooltip>
        );
    }
    return badge;
};

export interface IMessagingPillProps {
    children: React.ReactNode;
    title?: React.ReactNode;
    note?: boolean;
}

export const MessagingPill: React.FC<IMessagingPillProps> = ({ children, title, note }) => {
    const pill = <MessagingPillStyled note={note}>{children}</MessagingPillStyled>;
    if (title != null && title !== '') {
        return (
            <Tooltip direction="top" title={<span>{title}</span>}>
                {pill}
            </Tooltip>
        );
    }
    return pill;
};
